import React from "react";
import { Flex, Box, Heading, Text} from "rebass";
import ProjectTitleListing from "../components/ProjectTitleListing";

export default function Work() {
  return (
    <>
    <section>
    <Flex
      flexWrap="wrap"
      alignItems="center"
      variant="containerPage"
    >
      <Box width={[1/1]} mt={[0, 0, 0, 0, "-10.4rem"]} mb={[-4,-5]}>
        <Heading as="h3" variant="catHeading">Cases</Heading>
        <Text as="p" maxWidth="56.8rem">
          The Good and The Bad, lessons learned and things done the right way.
        </Text>
      </Box>
     </Flex>
     </section> 
      <ProjectTitleListing />  
    </>
  );
}
